import {Injectable} from '@angular/core';

import {AppErrorHandler} from "@shared/error-handler";
import {ErrorDialogComponent} from "@shared/components/error-dialog/error-dialog.component";
import {DialogService} from "@shared/services/dialog.service";

@Injectable({
  providedIn: 'root'
})
export class ShowErrorModalService {

  constructor(private dialogService: DialogService) {
  }

  showModal(error?: any, isAlwaysShown = false) {
    if (!isAlwaysShown && AppErrorHandler.errorDisplayed)
      return;

    this.dialogService.open(ErrorDialogComponent, error);
    AppErrorHandler.errorDisplayed = true;
  }
}
